define([
  'angular',
  'mod',
  'lodash'
], function(angular, mod, _) {

var m = require('am');

m.directive('arrayModel', [function() {
  // Enables a checkbox to manage its membership in an array.
  // `array-model` should evaluate to an array
  // `value` is what will be added to or removed from the array.
  // <input type="checkbox" array-model="model.array" value="{{value}}"/>
  return {
    scope: {
      'arrayModel': '=',
      'value': '@'
    },
    replace: true,
    template: '<input ng-change="toggle(value)" ng-model="local[value]" />',
    link: function(scope, element, attrs) {
      scope.local = {};

      if (scope.arrayModel === undefined) {
        scope.arrayModel = [];
      } else if (!_.isArray(scope.arrayModel)) {
        scope.arrayModel = [scope.arrayModel];
      }

      for (var i = 0; i < scope.arrayModel.length; i++) {
        scope.local[scope.arrayModel[i]] = true;
      }
      scope.toggle = function(value) {
        var index = scope.arrayModel.indexOf(value);
        if (element[0].checked && index === -1) {
          scope.arrayModel.push(value);
        } else if (index != -1) {
          scope.arrayModel.splice(index, 1);
        }
        scope.arrayModel.sort();
      };
    }
  };
}]);

m.directive('integer', function(){
  /*
  Ensures the ng-model value is stored as an integer.
  */
  return {
    require: 'ngModel',
    link: function(scope, ele, attr, ctrl){
      ctrl.$parsers.unshift(function(viewValue){
        return parseInt(viewValue, 10);
      });
    }
  };
});

m.directive('splitValue', function(){
  /*
  Split the value by a delimiter and store it in an array.
  */
  return {
    require: 'ngModel',
    link: function(scope, ele, attr, ctrl){
      var seperator = attr.splitBy || ' ';
      ctrl.$parsers.unshift(function(value){
        return _(value.split(seperator)).map(function(str) {
          return str.trim();
        }).uniq().value();
      });
      ctrl.$formatters.push(function(value) {
        return value && value.join(seperator);
      });
    }
  };
});

m.directive('autoSubmitWatch', [function() {
  return {
    link: function(scope, element, attrs) {
      scope.$watch(attrs.autoSubmitWatch, function(value) {
        scope.$eval(attrs.ngSubmit);
      }, true);
    }
  };
}]);

m.directive('tagger', ['$filter', function($filter) {
  return {
    restrict: 'E',
    scope: {
      model: '=',
      datalist: '='
    },
    require: '^?tabmaster',
    replace: true,
    templateUrl: require('common/Forms/tagger.html'),
    link: function(scope, element, attrs, TabCtrl) {
      if (scope.model === undefined) {
        scope.model = [];
      }

      scope.add_tag = function(tag) {
        if (tag && scope.model.indexOf(tag) === -1) {
          scope.model.push(tag);
          scope.model.sort();
        }
        scope.tag = '';
      };

      scope.remove_tag = function(tag) {
        var index = scope.model.indexOf(tag);
        if (index !== -1) {
          scope.model.splice(index, 1);
        }
      };

      scope.focus_input = function() {
        TabCtrl.focus_visible(0);
      };

      scope.unused = function(tag) {
        return !_.contains(scope.model, tag);
      };
    }
  };
}]);

m.directive('tabmaster', [function() {
  return {
    controller: ['$scope', function($scope) {
      var children = [];
      this.add_child = function(element) {
        return children.push(element) - 1;
      };

      this.focus_visible = function(i) {
        var el = children[i][0];
        if (el.offsetWidth > 0 || el.offsetHeight > 0) {
          el.focus();
          return true;
        }
      };
      this.up = function(i) {
        try {
          i--;
          while (!this.focus_visible(i)) {
            i--;
          }
        } catch(e) {}
      };
      this.down = function(i) {
        try {
          i++;
          while (!this.focus_visible(i)) {
            i++;
          }
        } catch(e) {}
      };
    }]
  };
}]);

m.directive('tabindex', [function() {
  return {
    require: '^?tabmaster',
    link: function(scope, element, attrs, TabCtrl) {
      if(TabCtrl && attrs.tabindex !== '-1') {
        var index = TabCtrl.add_child(element);
        element.on('keydown', function(ev) {
          if (ev.keyCode === 38) { // Up
            TabCtrl.up(index);
            ev.preventDefault();
            ev.stopPropagation();
          } else if (ev.keyCode === 40) { // Down
            TabCtrl.down(index);
            ev.preventDefault();
            ev.stopPropagation();
          }
        });
      }
    }
  };
}]);

m.directive('requireMatch', [function() {
  return {
    require: 'ngModel',
    scope: {
      requireMatch: '='
    },
    link: function($scope, $elem, $attrs, ctrl) {
      $scope.$watch(function() {
        return $scope.requireMatch === ctrl.$viewValue;
      }, function(matches) {
        if (matches) {
          ctrl.$setValidity('requireMatch', true);
        } else {
          ctrl.$setValidity('requireMatch', false);
        }
      });
    }
  };
}]);

m.directive('fieldErrors', [function() {
  return {
    scope: true,
    controller: ['$scope', '$attrs', function($scope, $attrs) {
      $scope.$watch(function() {
        return $scope.$eval($attrs.fieldErrors);
      }, function(input) {
        $scope.input = input;
      });
      $scope.$watch(function() {
        return $scope.input.$dirty && _.any($scope.e);
      }, function(show) {
        $scope.show = show;
      });
      $scope.$watchCollection('input.$error', function(errors) {
        $scope.e = errors;
      });
    }]
  };
}]);

m.directive('focusIf', ['$interval', function($interval) {
  return function($scope, $elem, $attr) {
    if ($scope.$eval($attr.focusIf)) {
      var el = $elem[0];
      var p = $interval(function() {
        if(el.clientWidth > 0) {
          el.focus();
          $interval.cancel(p);
        }
      }, 100, 10, false);
    }
  };
}]);

m.factory('handleResponse', ['notify', '$q', function(notify, $q) {
  return {
    success: function(message) {
      notify(message || 'Saved', {timeout: 3000});
    },
    failure: function(error) {
      if (error.message != "transition prevented" && error.message != 'transition superseded') {
        notify.error(error.data && error.data.message || error.data || error.toString());
      }
      return $q.reject(error);
    }
  };
}]);

m.directive('editResource', ['handleResponse', '$state', '$window', '$api', '$q',
 function(handle, $state, $window, $api, $q) {
  return {
    scope: true,
    require: 'form',
    link: function($scope, $elem, $attrs, FormCtrl) {
      var resource = $scope.$eval($attrs.editResource);
      $scope.pristine = _.cloneDeep(resource);

      var options = $scope.$eval($attrs.saveOptions) || {};

      $elem.on('submit', function() {
        FormCtrl.saving = true;
        if (options.before_save) options.before_save(resource);
        resource.$put(options)
          .finally(function() {
            FormCtrl.saving = false;
          })
          .then(function(updated) {
            handle.success();
            FormCtrl.$setPristine();

            if ($attrs.callback) {
              var callback = $scope.$eval($attrs.callback);
              if(callback) callback(updated);
            }
            if ($attrs.redirect) {
              return $state.go($attrs.redirect, {}, {reload: true});
            }
          })
          .catch(handle.failure);
      });

      if (options.confirm_exit) {
        var confirm_message = 'You have unsaved changes. Are you sure you wish to leave?';
        $window.onbeforeunload = function() {
          if ($scope.form.$dirty) {
            return confirm_message;
          }
        };
        $scope.$on('$destroy', function() {
          $window.onbeforeunload = undefined;
        });

        var already_leaving;
        var dirty_exit = function(toState, toParams) {
          $api.flush();
          return $state.go(toState, toParams, {reload: true})
            .finally(function() {
              already_leaving = false;
            });
        };
        $scope.$on('$stateChangeStart', function(event, toState, toParams) {
          if (FormCtrl.$dirty && !already_leaving) {
            event.preventDefault();
            var ask_confirm = options.confirm_exit(resource, toState, toParams);
            if (!ask_confirm || confirm(confirm_message)) {  // eslint-disable-line no-alert
              already_leaving = true;
              if (options.dirty_exit) {
                $q.when(options.dirty_exit(resource, toState, toParams)).then(function(do_default) {
                  if (do_default !== false) {
                    dirty_exit(toState, toParams);
                  }
                });
              } else {
                dirty_exit(toState, toParams);
              }
            }
          }
        });
      }

    }
  };
}]);

m.directive('addResource', ['handleResponse', '$q', '$stateParams',
 function(handle, $q, $stateParams) {

  return {
    scope: true,
    require: 'form',
    link: function($scope, $elem, $attrs, FormCtrl) {
      var collection = $scope.$eval($attrs.collection);
      if (_.isUndefined(collection)) {
        throw new Error('A collection is required');
      }
      if (_.isUndefined($scope.$eval($attrs.addResource))) {
        $scope[$attrs.addResource] = {};
      }

      function done() {
        FormCtrl.saving = false;
        handle.success();
      }

      $elem.on('submit', function() {
        FormCtrl.saving = true;
        collection.$post($scope.$eval($attrs.addResource))
          .then(function(item) {
            if ($attrs.callback) {
              return $q.when($scope.$eval($attrs.callback)(item));
            } else {
              return done();
            }
          })
          .catch(handle.failure)
          .finally(function() {
            FormCtrl.saving = false;
          });
      });
    }
  };
}]);

m.directive('deleteResource', ['$state', 'handleResponse', function($state, handle) {
  return {
    scope: {
      resource: '=deleteResource',
      redirect: '@'
    },
    link: function($scope, $elem) {
      $elem.on('click', function() {
        $scope.resource.$delete()
          .then(function() {
            if ($scope.redirect) {
              $state.go($scope.redirect, {}, {reload: true}).then(function() {
                handle.success('Deleted');
              });
            } else {
              handle.success('Deleted');
            }
          })
          .catch(handle.failure);
      });
    }
  };
}]);

m.directive('confirmAction', function(){
  return{
    scope: {
      confirm : '&confirmAction',
    },
    transclude: 'element',
    replace: true,
    template: '<span><span class="conf_wrapper"><span class="conf_btn" ng-click="open()" ng-transclude></span><span class="conf_opts"><button class="btn_link" type="button" ng-click="cancel()">No</button><button class="btn_small btn_green" type="button" ng-click="confirm()">Yes</button></span></span></span>',
    link: function($scope, $elem, $attr){
      $scope.cancel = function(){
        $elem.removeClass('conf_active');
        console.log('cancel');
      };
      $scope.open = function(){
        $elem.addClass('conf_active');
        console.log('open');
      };
    }
  };
});

m.directive('slidingSwitch', ['$timeout', function($timeout){
  return{
    scope: {
      model:'=slidingSwitch',
      onLabel: '@',
      offLabel: '@',
      onSwitch: '&'
    },
    templateUrl: require('common/Forms/sliding-switch.html'),
    link: function($scope) {
      $scope.change = function() {
        return $timeout($scope.onSwitch, 0);
      };
    }
  };
}]);

m.directive('inputWrap', function(){
  return{
    restrict: 'C',
    link: function($scope, $elem, $attr){
      var input = $elem[0].querySelector('input[type="checkbox"], input[type="radio"]');
      var type = input.type;
      if (input) {
        $scope.$watch(function() {
          return input.checked;
        }, function(checked) {
          if (checked) {
            $elem.addClass(type + '_checked');
          } else {
            $elem.removeClass(type + '_checked');
          }
        });
      }
    }
  };
});

return m;
});



/** WEBPACK FOOTER **
 ** /mnt/jenkins/jobs/master/workspace/core/client/common/Forms/Forms.js
 **/